import { render, staticRenderFns } from "./HomeCommerce.vue?vue&type=template&id=214de12e"
import script from "./HomeCommerce.vue?vue&type=script&lang=js"
export * from "./HomeCommerce.vue?vue&type=script&lang=js"
import style0 from "./HomeCommerce.vue?vue&type=style&index=0&id=214de12e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports